// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#nprogress .bar {\r\n    background: red !important;\r\n    /*z-index: 10310;*/\r\n    /* top: 80px; */\r\n}\r\n\r\n#nprogress .peg {\r\n    box-shadow: 0 0 10px red, 0 0 5px red !important;\r\n}\r\n\r\n#nprogress .spinner-icon {\r\n    border-top-color: red !important;\r\n    border-left-color: red !important;\r\n}", ""]);
// Exports
module.exports = exports;
